<template lang="html">
    <div class="tag-master-data-container">
        <span class="title">Tag Master Data</span>
        <div class="master-tags-section-container">
            <input type="file" style="display:none;" ref="masterTagUploadInput" id="masterTagUploadInput" @change="inputCallback"
                accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel, .xlsm" />
            <div class="master-tag-section" :class="{'available-master' : isEquipmentMasterAvailable}">
                <span>Equipment Master</span>
                <div :class="['btn-hover-orange', 'cursor-pointer', 'fas', isDownloadingEquipment ? 'fa-spinner spinning' : 'fa-download']"
                    @click.stop="downloadMasterExcel('Equipment')" title="Download Equipment Master"></div>
                <div :class="['btn-hover-orange', 'cursor-pointer', 'fas', isUploadingEquipment ? 'fa-spinner spinning' : 'fa-upload']"
                    @click.stop="showExcelBrowse('Equipment')" title="Upload Equipment Master"></div>
                <div :class="['btn-hover-orange', 'cursor-pointer', 'fas', isDeletingEquipment ? 'fa-spinner spinning' : 'fa-trash']"
                    @click.stop="deleteUntaggedMaster('Equipment')" title="Delete all un-tagged Equipment Master"></div>
            </div>

            <div class="master-tag-section" :class="{'available-master' : isPipelineMasterAvailable}">
                <span>Pipeline Master</span>
                <div :class="['btn-hover-orange', 'cursor-pointer', 'fas', isDownloadingPipeline ? 'fa-spinner spinning' : 'fa-download']"
                    @click.stop="downloadMasterExcel('Pipeline')" title="Download Pipeline Master"></div>
                <div :class="['btn-hover-orange', 'cursor-pointer', 'fas', isUploadingPipeline ? 'fa-spinner spinning' : 'fa-upload']"
                    @click.stop="showExcelBrowse('Pipeline')" title="Upload Pipeline Master"></div>
                <div :class="['btn-hover-orange', 'cursor-pointer', 'fas', isDeletingPipeline ? 'fa-spinner spinning' : 'fa-trash']"
                    @click.stop="deleteUntaggedMaster('Pipeline')" title="Delete all un-tagged Pipeline Master"></div>
            </div>

            <div class="master-tag-section" :class="{'available-master' : isStructuralMasterAvailable}">
                <span>Structural Master</span>
                <div :class="['btn-hover-orange', 'cursor-pointer', 'fas', isDownloadingStructural ? 'fa-spinner spinning' : 'fa-download']"
                    @click.stop="downloadMasterExcel('Structural')" title="Download Structural Master"></div>
                <div :class="['btn-hover-orange', 'cursor-pointer', 'fas', isUploadingStructural ? 'fa-spinner spinning' : 'fa-upload']"
                    @click.stop="showExcelBrowse('Structural')" title="Upload Structural Master"></div>
                <div :class="['btn-hover-orange', 'cursor-pointer', 'fas', isDeletingStructural ? 'fa-spinner spinning' : 'fa-trash']"
                    @click.stop="deleteUntaggedMaster('Structural')" title="Delete all un-tagged Structural Master"></div>
            </div>
        </div>
    </div>
</template>
<script>
import HttpService from '../../../utils/httpService';
export default {
    name: "TagMasterData",
    data() {
        return {
            isDownloadingEquipment: false,
            isUploadingEquipment: false,
            isDeletingEquipment: false,
            isDownloadingPipeline: false,
            isUploadingPipeline: false,
            isDeletingPipeline: false,
            isDownloadingStructural: false,
            isUploadingStructural: false,
            isDeletingStructural: false,
            inputCallback: console.log,
        };
    },
    mounted() {
        this.$store.dispatch('GET_MASTERS_STATUS')
    },
    methods: {
        showExcelBrowse(type) {
            if (this.isUploadingEquipment || this.isUploadingPipeline || this.isUploadingStructural) return;

            this.inputCallback = this.uploadMasterExcel.bind(this, type);

            this.$refs.masterTagUploadInput.click();
        },
        downloadMasterExcel(type) {
            if (this[`isDownloading${type}`]) return;

            let downloadCallback = (includeExisting) => {                
                this[`isDownloading${type}`] = true;

                console.log(`🔻 Downloading ${type} Master Template`);

                const link = document.createElement('a');
                link.setAttribute('download', `${type} Master.xlsm`);
                document.body.appendChild(link);

                HttpService.get({
                    url: `api/tags/${type.toLowerCase()}/exportExcel/${this.assetId}?includeExisting=${includeExisting}`,
                    responseType: 'blob',
                }).then((response) => {
                    let blob = response.data;
                    const objectUrl = URL.createObjectURL(blob);
                    link.setAttribute('href', objectUrl);
                    link.click();
                    URL.revokeObjectURL(objectUrl);
                }).catch(({ message }) => {
                    console.error(message);
                    this.$store.dispatch("alert_Forge", {
                        message: `Failed to download ${type} Master Template`,
                    });
                }).finally(() => {
                    document.body.removeChild(link);
                    this[`isDownloading${type}`] = false;
                });
            }

            this.$store.dispatch({
                type: "confirm_Forge",
                message: 'You are about to download the template.\n\nDo you want to include the existing records?', 
                callback: () => {
                    downloadCallback(true);
                },
                cancelCallback: () => {
                    downloadCallback(false);
                }
            })
        },
        uploadMasterExcel(type) {
            if (this[`isUploading${type}`]) return;

            console.log(`🔺 Uploading ${type} Master Template`);

            this[`isUploading${type}`] = true;

            let file = this.$refs.masterTagUploadInput.files[0];
            let formData = new FormData();
            formData.set('file', file);

            HttpService.post({
                url: `api/tags/${type.toLowerCase()}/importExcel/${this.assetId}`,
                data: formData,
                headers: {
                    'Content-Type': false,
                    'processData': false,
                },
            }).then(() => {
                this.$store.dispatch('GET_MASTERS_STATUS');
                this.$store.dispatch('showSuccessfulMessage', {
                    message: `Tags updated successfully.`,
                    timeout: 3000
                });
            }).catch(error => {
                console.error(error.message);
                this.$store.dispatch("alert_Forge", {
                    message: `An Error occurred when updating ${type} tags.`
                });
            }).finally(() => {
                this[`isUploading${type}`] = false;
                this.$refs.masterTagUploadInput.value = "";
            });
        },
        deleteUntaggedMaster(type) {
            if (this[`isDeleting${type}`]) return;

            this.$store.dispatch({
                type: "confirm_Forge",
                message: `Are you sure you want to delete un-tagged ${type} Master?`, callback: () => {
                    this[`isDeleting${type}`] = true;
        
                    HttpService.post({
                        url: `api/tags/deleteUntaggedMaster/${type}/${this.assetId}`,
                    }).then(({ data }) => {
                        this.$store.dispatch('GET_MASTERS_STATUS');
                        this.$store.dispatch('showSuccessfulMessage', {
                            message: `${data} un-tagged ${type} tags deleted successfully.`, timeout: 3000
                        })
                    }).catch(error => {
                        console.error(error.message);
                        this.$store.dispatch("alert_Forge", {
                            message: `An Error occurred when deleting un-tagged ${type} tags.`
                        })
                    }).finally(() => {
                        this[`isDeleting${type}`] = false;
                    });
                }
            })

        },
    },
    computed: {
        assetId() {
            return this.$store.state.assetId;
        },
        isEquipmentMasterAvailable() {
            return this.$store.getters.GET_IS_EQUIPMENT_MASTER_AVAILABLE;
        },
        isPipelineMasterAvailable() {
            return this.$store.getters.GET_IS_PIPELINE_MASTER_AVAILABLE;
        },
        isStructuralMasterAvailable() {
            return this.$store.getters.GET_IS_STRUCTURAL_MASTER_AVAILABLE;
        },
    },
    watch: {}
}
</script>
<style lang="css">
.tag-master-data-container {
    padding: 10px 10px;
    display: flex;
    align-items: center;
    column-gap: 30px;
}
.tag-master-data-container .title{
    font-size: 16px;
    font-weight: 600;
}
.master-tags-section-container {
    display: flex;
    margin-inline-start: 20px;
    column-gap: 30px;
}
.master-tag-section {
    display: flex;
    align-items: center;
    column-gap: 5px;
}
.master-tag-section span {
    font-size: 12px;
    font-weight: 600;
    border: 1px solid #2f2f2f;
    padding: 5px 15px;
    border-radius: 3px;
    background: #f2f2f2;
    user-select: none;
}

.master-tag-section.available-master span {
    background: #c1ffb2;
    border-color: #96b73a;
}
</style>